'use client';

import Script from 'next/script';

import { useDecagonContext } from '../contexts/DecagonProvider';

const DecagonScript = () => {
  const { onScriptLoaded } = useDecagonContext();

  const onLoad = () => {
    onScriptLoaded();
  };

  return (
    <Script
      async
      id="decagon-script"
      data-cy="decagon-script"
      src="https://decagon.ai/loaders/oura_embed.js"
      onLoad={onLoad}
      onError={(e: Error) => {
        // eslint-disable-next-line no-console
        console.error('Decagon script failed to load', e);
      }}
    />
  );
};

export default DecagonScript;
